import { type MouseEvent } from 'react';
import Truncate from 'react-truncate';

import { Box } from '@hivebrite/design-system/Box';
import { Card } from '@hivebrite/design-system/Card';
import {
  CATEGORIES,
  FontAwesomeIcon,
} from '@hivebrite/design-system/FontAwesomeIcon';
import {
  UserPresentation,
  USER_PRESENTATION_AVATAR_SIZES,
} from '@hivebrite/design-system/UserPresentation';

import { type CardPinnedProps } from 'hb-react/frontoffice/apps/Forum/components/CardPinned';
import UserSnapshot from 'hb-react/shared/components/UserSnapshot';
import onEnterOrSpacePress from 'hb-react/shared/utils/onEnterOrSpacePress';

export interface CardPinnedUIProps extends CardPinnedProps {
  onClick: (event: MouseEvent<HTMLDivElement>) => void;
}

const CardPinnedUI = ({
  comments,
  likes,
  onClick,
  title,
  user,
}: CardPinnedUIProps) => {
  const { photo_thumb_url: photoThumbUrl, name } = user;
  const isLikedByCurrentUser = likes.id || likes.currentUserLiked;

  return (
    <Card
      height="100%"
      p={4}
      tabIndex={0}
      onClick={onClick}
      onKeyPress={onEnterOrSpacePress(onClick)}
      style={{ cursor: 'pointer' }}
    >
      <Box flexDirection="column" justifyContent="space-between" height="100%">
        <Box
          display="block"
          data-testid="card-forum-user-presentation"
          aria-label={name}
        >
          <UserSnapshot userId={user.id}>
            <UserPresentation
              avatar={photoThumbUrl}
              size={USER_PRESENTATION_AVATAR_SIZES.SMALL}
              name={name}
              ariaLabel={name || s__('Forum|User link to profile')}
            />
          </UserSnapshot>
          <Box as="h3" font="h3-semibold" pt={2} pb={3}>
            <Truncate lines={3}>{title}</Truncate>
          </Box>
        </Box>
        <Box>
          <Box mr={2} alignItems="center" dataTestId="card-forum-likes">
            {/* likes.currentUserLiked is sent by new endpoint dynamic components - Builder */}
            <FontAwesomeIcon
              color={isLikedByCurrentUser ? 'primary' : 'asphalt'}
              height="20px"
              iconName="heart"
              iconType={
                isLikedByCurrentUser ? CATEGORIES.SOLID : CATEGORIES.LIGHT
              }
            />
            <Box ml={2} font="body-regular-asphalt">
              {likes.count}
            </Box>
          </Box>
          <Box mr={2} alignItems="center" dataTestId="card-forum-comments">
            <FontAwesomeIcon
              color="asphalt"
              height="20px"
              iconName="message"
              iconType={CATEGORIES.LIGHT}
            />
            <Box ml={2} font="body-regular-asphalt">
              {comments.total}
            </Box>
          </Box>
        </Box>
      </Box>
    </Card>
  );
};

export default CardPinnedUI;
